import { render, staticRenderFns } from "./AreaChart.vue?vue&type=template&id=6c07bc1e&scoped=true"
import script from "./AreaChart.vue?vue&type=script&setup=true&lang=js"
export * from "./AreaChart.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AreaChart.vue?vue&type=style&index=0&id=6c07bc1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c07bc1e",
  null
  
)

export default component.exports